<template>
  <div>
    <Navbar />
      <div class="owner-body">
        <div class="sidebar">
            <Sidebar />
        </div>
        <div class="page">
          <card-component class="card-component">
            <div class="expansion">
                <div class="heading">
                    <h3>Expansion</h3>
                </div>
                    <div class="expansion-container">
                      <div class="choose-facility">
                        <label for="Choose facility">Choose facility for expansion</label>
                        <b-field class="choose-facility-field">
                            <b-select
                                placeholder="Default"
                                expanded>
                                <option value="flint">Flint</option>
                                <option value="silver">Silver</option>
                            </b-select>
                        </b-field>
                      </div>
                      <div class="projected-capacity">
                        <label for="Choose facility">Projected capacity</label>
                        <b-input v-model="capacity"></b-input>
                      </div>
                      <div class="location">
                        <label for="Choose facility">Location</label>
                        <b-input v-model="address"></b-input>
                      </div>
                      <div class="state">
                        <!-- <label for="Choose facility">State</label> -->
                        <b-field>
                            <b-select
                                placeholder="State"
                                expanded>
                                <option value="flint">Flint</option>
                                <option value="silver">Silver</option>
                            </b-select>
                        </b-field>
                      </div>
                      <b-button class="submit-button">
                        Submit request
                      </b-button>
                    </div>
            </div>
          </card-component>
          <card-component>
              <div class="complaint">
                <div class="heading">
                    <h3>Complaint</h3>
                </div>
                <div class="complaint-container">
                    <div class="choose-category">
                        <label for="Choose category">Choose category</label>
                        <b-field>
                            <b-select
                                placeholder="Default"
                                expanded>
                                <option value="flint">Flint</option>
                                <option value="silver">Silver</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="subject">
                        <label for="Subject">Subject</label>
                        <b-input v-model="subject"></b-input>
                    </div>
                    <div class="about-need">
                      <label for="about need">Tell us about what you need</label>
                      <b-field>
                        <b-input maxlength="200" type="textarea"></b-input>
                      </b-field>
                    </div>
                    <div class="complaint-buttons">
                      <b-button class="submit-button">
                        Submit request
                      </b-button>
                      <b-button class="cancel-button">
                        Cancel
                      </b-button>
                    </div>
                </div>
              </div>
          </card-component>
        </div>
      </div>
  </div>
</template>

<script>
import Navbar from '@/components/NavBar.vue';
import Sidebar from '@/components/OwnerSidebar.vue';
import CardComponent from '@/components/CardComponent.vue';

export default {
  components: {
    Navbar,
    Sidebar,
    CardComponent
  }
};
</script>

<style scoped>
.heading h3 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #736F6F;
  margin-bottom: 27px;
  text-transform: capitalize;
}
.heading {
  border-bottom: 1px solid #C4C4C4;
}
.expansion-container {
  max-width: 470px;
}
label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  color: #000000;
}
.submit-button {
  background: #3887F6;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: -0.4px;
  color: #FFFFFF;
}
.control{
  width: 100%;
}
.choose-facility, .projected-capacity, .location, .state, .submit-button {
  margin-top: 30px;
}
.choose-facility label, .projected-capacity label, .location label, .state label {
  margin-bottom: 10px;
}
/*  */
/* compalint */
.complaint-container {
  max-width: 470px;
}
.complaint-buttons {
  display: flex;
  align-items: center;
}
.cancel-button {
  letter-spacing: -0.4px;
  color: #FFFFFF;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: -0.4px;
  text-decoration-line: underline;
  color: #5051DB;
  border: none;
  margin-top: 30px;
  margin-left: 20px;
}
.choose-category, .subject, .about-need {
  margin-top: 30px;
}
</style>
